import { render, staticRenderFns } from "./CommonSingleImage.vue?vue&type=template&id=0d6da158"
import script from "./CommonSingleImage.vue?vue&type=script&lang=js"
export * from "./CommonSingleImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports